import React from 'react';

import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';


//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Icon} from '../inspinia'
import Pagination from "react-js-pagination";
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getToken } from '../../store/auth';

class RemetentesValidate extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: false, filter: "", page: 0,
            form: this.formInitialState(),
            list:
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, content: undefined
            },
            emailUsuario: this.props.auth.user.email,
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
            buttonInclude: 'Incluir',
            alerta: withReactContent(Swal)

        }

        this.handleBuscarInput      = this.handleBuscarInput.bind(this); 
        this.handlePageChange       = this.handlePageChange.bind(this);
        this.handleAdicionarRemetente = this.handleAdicionarRemetente.bind(this);
        this.handleChange           = this.handleChange.bind(this);
        this.handleLimparPesquisa   = this.handleLimparPesquisa.bind(this);
        this.handleMensagemSucesso = this.handleMensagemSucesso.bind(this);
        this.handleCancelaEdicao = this.handleCancelaEdicao.bind(this);
        this.handleMensagemSucesso = this.handleMensagemSucesso.bind(this);
        this.handleMensagemEdicao = this.handleMensagemEdicao.bind(this);
    }

    formInitialState() {
        return {
            id: "",
            remetente: ""
        }
    }

    componentDidMount()
    {
        this.LoadListRemetente();
    }

    handleMensagemSucesso(remetente) {
        this.state.alerta.fire({
            icon: 'success',
            text: `Remetente ${remetente} cadastrado com sucesso!`,
            showConfirmButton: false,
            timer: 1500
        });
    }

    handleMensagemEdicao(remetente) {
        this.state.alerta.fire({
            icon: 'success',
            text: `Remetente ${remetente} editado com sucesso!`,
            showConfirmButton: false,
            timer: 1500
        });
    }

    handleLimparPesquisa(edicao) {

        let remetente = this.state.form.remetente;

        this.state.list = [];
        this.state.form.id = "";
        this.state.form.remetente = "";

        if (edicao) {
            this.handleMensagemEdicao(remetente);

        } else {
            this.handleMensagemSucesso(remetente);

        }

        this.LoadListRemetente();
    }

    handleChange(e) {

        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value.toLowerCase() } });

    }

    onRemetenteChange(remetenteEdicao) {
        const form = this.state.form;
        this.setState({ form: { ...form, remetente: remetenteEdicao.sender, id: remetenteEdicao.id }, buttonInclude: 'Salvar' });

    }

    onLoadingChange(loading) {

        this.setState({...this.state, loading})

    }

    handleAdicionarRemetente() {
        const form = this.state.form;

        if(form.remetente.length == 0){
            c.TOASTER_ERROR(`Favor preencher o remetente!`);  
            return;
        }
        
        if(form.id === ''){
            this.SaveRemetente();

        } else {
            this.EditarRemetente(form.id);
        }
        
    }

    handleCancelaEdicao() {
        this.setState({ ...this.state, buttonInclude: 'Incluir', form: this.formInitialState() });
    }

    SaveRemetente(e) {
        let self = this;
        let url = `${c.API_BASE_URL}/sender-validator`;
    
        self.setState({ ...self.state, loading: true });
        
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': c.AUTH_HEADER(getToken()) },
            body: JSON.stringify({      
                sender: this.state.form.remetente
            })
        };
    
        fetch(url, options)
            .then(async (response) => {
                const data = await response.json();
                if (response.status === 200 || response.status === 201) {
                    console.log(data);
                    self.setState({ ...self.state, page: data.number }, self.handleLimparPesquisa());
                } else if (response.status === 409 || response.status === 400) {
                    c.TOASTER_ERROR(data.message);
                    self.setState({ loading: false });
                } else {
                    console.log(`Erro: `, data.message);
                    c.TOASTER_ERROR('Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.');
                    self.setState({ loading: false });
                }
            })
            .catch((error) => {
                console.error('Erro na chamada da API:', error);
                c.TOASTER_ERROR('Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.');
                self.setState({ loading: false });
            });
    }    
    
    EditarRemetente(idRemetente) {

        let self = this;
        let url = `${c.API_BASE_URL}/sender-validator`
        const options = {
            method: 'PATCH' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({      
                id: idRemetente,
                sender: this.state.form.remetente
            })
        };    

        callApi(url, options, function(response)
        { 
            self.setState({ ...self.state, loading: false, page: 0, buttonInclude: 'Incluir' }, self.handleLimparPesquisa(true));      
        });

    }

    handleBuscarInput(e)
    {
        this.setState({ ...this.state, filter: e.target.value });   
    }

    handlePageChange(pageNumber) 
    {

        this.state.page = pageNumber;
        this.LoadListRemetente(pageNumber);
    }

    render()
    {
        return (                     
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Listas de Remetentes Válidos</h3>
                            </Title>

                            <Content>
                                
                                <Row className="m-0 mb-2">
                                    <Column size="12" className="p-0 mx-auto container">

                                        <Row className="form-row">
                                            <div className="form-group col-md-3">   
                                                <input 
                                                    type="text" 
                                                    name="remetente" 
                                                    value={this.state.form.remetente} 
                                                    onChange={this.handleChange} 
                                                    className="form-control" 
                                                    placeholder="Remetente"
                                                    maxLength={30}
                                                    pattern="[A-Za-z0-9._%+-]*"
                                                />                                                 
                                            </div>
                                            <div className="form-group col-md-1">
                                                <Button onClick={this.handleAdicionarRemetente} className="btn btn-primary">{this.state.buttonInclude}</Button>                                                   
                                            </div>
                                            <div className="form-group col-md-5">
                                                <Button onClick={this.handleCancelaEdicao} className="btn btn-danger">Cancelar</Button>                                                   
                                            </div> 
                                            <div className="form-group col-md-3">
                                                {this.state.loading && (                    
                                                    <CircularProgress />                    
                                                )}
                                            </div>  
                                                                            
                                        </Row> 
                                        
                                    </Column>
                                    
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this.props.history} contexto={this}/>                                        
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>                     
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.size}
                                        totalItemsCount={this.state.list.totalElements}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>                
            </div>
        );
    }
 
    LoadListRemetente(pageNumber)
    {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;
        
        const url = `${c.API_BASE_URL}/sender-validator?page=${page}&size=${size}`;
        const options = self.state.optionsGet;
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, list: response});
        });
    }

}

class Table extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            pesquisa: "",
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } }
        }

        this.editarClick = this.editarClick.bind(this);
        this.excluirClick = this.excluirClick.bind(this);
        this.handlePesquisa = this.handlePesquisa.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleLimparBusca = this.handleLimparBusca.bind(this);
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value.toLowerCase() });
    }

    handlePesquisa() {
        let self = this;
        let page = 0;
        let size = 10;
    
        const _token = getToken();
        const url = `${c.API_BASE_URL}/sender-validator?page=${page}&size=${size}&sender=${self.state.pesquisa}`;
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': c.AUTH_HEADER(_token) }
        }
    
        self.setState({ ...self.state, loading: true });

        fetch(url, options).then(async (response) => {
            const data = await response.json();
            if (response.status === 200) {
                self.props.contexto.setState({ list: data });
                self.setState({ ...self.state, loading: false });
            } else {
                self.props.contexto.setState({ list: { content: [] } });
                self.setState({ ...self.state, loading: false });
            }
        }).catch((error) => {
            self.props.contexto.setState({ list: { content: [] } });
            self.setState({ ...self.state, loading: false });
        });
    }

    handleLimparBusca() {
        this.setState({ ...this.state, pesquisa: "" });
        this.props.contexto.LoadListRemetente();
    }

    editarClick(id)
    {
        if (parseInt(id) === 0) return;        

        let remetentes = this.props.data.content;
        let remetente = '';

        remetente = remetentes.filter((sender) => sender.id === id);
        this.props.contexto.onRemetenteChange(remetente[0]);
    }


    excluirClick(id) {
        if (parseInt(id) === 0) return;

        Swal.fire({
            title: 'Realmente deseja excluir este Remetente?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            preConfirm: () => {
              return this.LoadExcluir(id);
            },
            allowOutsideClick: () => !Swal.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    icon: 'success',
                    text: 'Registro excluído com sucesso!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire({
                    icon: 'warning',
                    text: 'Exclusão cancelada!',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        });
    }

    LoadExcluir(id)
    {
        let self = this;
        let url = `${ c.API_BASE_URL }/sender-validator/${id}`
        
        const options =
        {
            method: 'DELETE'
            ,headers: { 'Content-Type': 'application/json' }
        };

        callApi(url, options, function(response)
        { 
            self.props.contexto.LoadListRemetente();
            self.props.contexto.onLoadingChange(false);
        });
    }

    render()
    {    
        const data = this.props.data; 
        let html = "";

        if (data.content === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.content.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.content.length   > 0)
        {
            html = data.content.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.sender}</td>
                    <td className="text-center">
                        <a onClick={() => this.editarClick(row.id)}><Icon name="fa-pencil" className="mx-1 text-success" /></a>
                        <a onClick={() => this.excluirClick(row.id)}><Icon name="fa-times" className="mx-1 text-muted" /></a>
                    </td>
                </tr>           
            );
        }

        return (
            <div>
                <table className="footable table table-striped toggle-arrow-tiny text-body">
                    <thead>
                    <tr style={{backgroundColor: "#dbf1e9"}}> 
                        <th>Remetente</th>
                        <th className="text-center">Ações</th>
                    </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>
                <Row className="m-0 mb-0">
                    <div className="form-group col-md-4">
                        <input type="text" name="pesquisa" value={this.state.pesquisa} onChange={this.handleChange} className="form-control" placeholder="Busca..." />
                    </div>
                    <div className="form-group col-md-1">
                        <Button onClick={this.handlePesquisa} className="btn btn-primary">Pesquisar</Button>
                    </div>
                    <div className="form-group col-md-1" style={{ marginLeft: '25px' }}>
                        <Button onClick={this.handleLimparBusca}><Icon name="far fa-trash" /> Limpar</Button>
                    </div>
                </Row>
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RemetentesValidate));